export default {"src":"/_next/static/media/GS-LinkedIn-White.7f673169.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};